import { useEffect, useState } from 'react';

export type Route =
  | { name: 'expeditions' }
  | { name: 'expedition'; exp: string }
  | { name: 'day'; exp: string; day: string }
  | { name: 'event'; exp: string; id: string }
  | { name: 'gaps'; exp: string }
  | { name: 'review'; exp: string }
  | { name: 'history'; exp: string; kind: string; id: string }
  | { name: 'settings'; exp?: string };

export function parseRoute(hash: string): Route {
  const p = hash.replace(/^#/, '') || '/';
  let m: RegExpMatchArray | null;
  if ((m = p.match(/^\/x\/([\w-]+)\/d\/(D\d{2})$/))) return { name: 'day', exp: m[1], day: m[2] };
  if ((m = p.match(/^\/x\/([\w-]+)\/e\/(D\d{2}-\d{2,3})$/))) return { name: 'event', exp: m[1], id: m[2] };
  if ((m = p.match(/^\/x\/([\w-]+)\/gaps$/))) return { name: 'gaps', exp: m[1] };
  if ((m = p.match(/^\/x\/([\w-]+)\/review$/))) return { name: 'review', exp: m[1] };
  if ((m = p.match(/^\/x\/([\w-]+)\/h\/(\w+)\/([\w~-]+)$/))) return { name: 'history', exp: m[1], kind: m[2], id: m[3] };
  if ((m = p.match(/^\/x\/([\w-]+)\/settings$/))) return { name: 'settings', exp: m[1] };
  if ((m = p.match(/^\/x\/([\w-]+)$/))) return { name: 'expedition', exp: m[1] };
  if (p === '/settings') return { name: 'settings' };
  return { name: 'expeditions' };
}

export const href = {
  home: () => '#/',
  expedition: (exp: string) => `#/x/${exp}`,
  day: (exp: string, day: string) => `#/x/${exp}/d/${day}`,
  event: (exp: string, id: string) => `#/x/${exp}/e/${id}`,
  gaps: (exp: string) => `#/x/${exp}/gaps`,
  review: (exp: string) => `#/x/${exp}/review`,
  history: (exp: string, kind: string, id: string) => `#/x/${exp}/h/${kind}/${id}`,
  settings: (exp?: string) => (exp ? `#/x/${exp}/settings` : '#/settings'),
};

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parseRoute(window.location.hash));
  useEffect(() => {
    const on = () => setRoute(parseRoute(window.location.hash));
    window.addEventListener('hashchange', on);
    return () => window.removeEventListener('hashchange', on);
  }, []);
  return route;
}
